<template>
    <div class="info-row">
        <div class="info-row-name">
            <span class="material-symbols-outlined icon">{{ icon }}</span>
            <span class="info-row-message">{{ name }}</span>
        </div>
        <div class="info-row-meta">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoRow",
    props: {
        name: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: "person",
        },
    },
};
</script>
